import { render, staticRenderFns } from "./DbDes.vue?vue&type=template&id=2c6956bf&scoped=true&"
import script from "./DbDes.vue?vue&type=script&lang=js&"
export * from "./DbDes.vue?vue&type=script&lang=js&"
import style0 from "./DbDes.vue?vue&type=style&index=0&id=2c6956bf&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6956bf",
  null
  
)

export default component.exports